import type { GoogleSearchSuggestionsResponse } from './types';
import type { GroupedSuggestions } from 'client-site-chrome-ui/components/molecules/SearchSuggestions/types';
import { buildSearchListingsPagePath } from 'client-site-chrome-ui/hooks/useSearch/utils/buildSearchPath';

export const transformGoogleSearchSuggestions = ({
  results,
}: GoogleSearchSuggestionsResponse): GroupedSuggestions => {
  const { suggestions } = results.searchTerms;

  return {
    groups: [
      {
        suggestions: suggestions.map(({ suggestion }, index) => ({
          globalIndex: index,
          name: suggestion,
          href: buildSearchListingsPagePath(suggestion, index + 1),
          type: 'term',
        })),
      },
    ],
    suggestionsCount: suggestions.length,
  };
};
